<template>
    <div id="header-component">
        <mds-page-shell
            :logo="morningstarLogo"
            :logo-responsive="morningstarLogo"
            logo-alt="Morningstar Logo"
        >
            <template #mds-page-shell-masthead-right>
                <mds-button
                    v-if="$route.name === 'Unauthorized' || $route.name === 'PaymentError'"
                    variation="secondary"
                    @click="logoutClicked()"
                >
                    Logout
                </mds-button>
            </template>
        </mds-page-shell>
    </div>
</template>
<script>

import MdsPageShell from "@mds/page-shell";
import { MdsButton } from "@mds/button";
import morningstarLogo from "../../assets/images/mstarLogo.svg";

export default {
    components: {
        MdsPageShell,
        MdsButton
    },
    data() {
        return {
            morningstarLogo,
            logoutURL: process.env.VUE_APP_LOGOUT_URL
        };
    },
    methods: {
        logoutClicked() {
            window.location.href = this.logoutURL;
        }
    }
};
</script>
